'use es6';

import { useCallback, useState, useMemo } from 'react';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIButton from 'UIComponents/button/UIButton';
import UIList from 'UIComponents/list/UIList';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CommentActions = ({
  handleClickToDelete,
  onClickToDeleteComment
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const onDeleteComment = useCallback(() => {
    handleClickToDelete();
    setModalOpen(false);
  }, [handleClickToDelete, setModalOpen]);
  const onOpenModal = useCallback(() => {
    onClickToDeleteComment();
    setModalOpen(true);
  }, [onClickToDeleteComment, setModalOpen]);
  const onCloseModal = useCallback(() => {
    setModalOpen(false);
  }, [setModalOpen]);
  const deleteCommentModal = useMemo(() => {
    return /*#__PURE__*/_jsxs(UIModal, {
      use: "danger",
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onCloseModal
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        children: /*#__PURE__*/_jsx("h2", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-message-history.commentActions.dialogBody"
          })
        })
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-message-history.commentActions.dialogFooter"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: onDeleteComment,
          "data-test-id": 'delete-comment-button',
          use: "danger",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-message-history.commentActions.deleteCommentButton"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: onCloseModal,
          use: "tertiary-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-message-history.commentActions.cancel"
          })
        })]
      })]
    });
  }, [onDeleteComment, onCloseModal]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(UIDropdown, {
      "data-test-id": 'actions-dropdown',
      buttonUse: "transparent",
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.commentActions.actions"
      }),
      style: {
        paddingTop: 3,
        paddingBottom: 5,
        fontSize: 12
      },
      children: /*#__PURE__*/_jsx(UIList, {
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "link",
          "data-test-id": 'open-modal-button',
          onClick: onOpenModal,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-message-history.commentActions.deleteCommentButton"
          })
        })
      })
    }), isModalOpen ? deleteCommentModal : null]
  });
};
CommentActions.displayName = 'CommentActions';
CommentActions.propTypes = {
  handleClickToDelete: PropTypes.func.isRequired,
  onClickToDeleteComment: PropTypes.func.isRequired
};
export default CommentActions;